// extracted by mini-css-extract-plugin
export default {"component":"CheckBox_component__atelz","checkedWrapper":"CheckBox_checkedWrapper__YyaXl","customCheckbox":"CheckBox_customCheckbox__gWCDB","label":"CheckBox_label__Q0Qga"};